import styled from 'styled-components';

export const Wrapper = styled.div<{ $bgImage: string }>`
	padding: 12px 8px 4px 8px;
	width: 100%;
	height: 112px;
	border-radius: 4px;
	background: ${({ theme }) => theme.colors.background.main};
	background-image: ${({ $bgImage }) => `url('${$bgImage}')`};
	background-size: cover;
	background-position: right bottom;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-start;
	overflow: hidden;
	position: relative;

	@media (max-width: 1100px) {
		width: 100%;
	}
`;

export const BgImage = styled.img`
	position: absolute;
	inset: auto;
	object-fit: cover;
	right: 0;
	pointer-events: none;
	z-index: 1;
`;

export const Title = styled.h2`
	font-size: 16px;
	line-height: 22px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.subtitle};
	padding-left: 4px;
`;

export const Link = styled.div`
	font-size: 13px;
	line-height: 18px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	position: relative;

	svg {
		position: absolute;
		width: 20px;
		height: 20px;

		path {
			fill: ${({ theme }) => theme.colors.text.alwaysWhite};
		}
	}
`;
